import { AuxiliumComponent } from "../auxilium-component";

export class SidebarHeader extends AuxiliumComponent {
	constructor() {
		super();

		this.icon = this.getAttribute("icon") ?? "";
		this.iconColour = this.getAttribute("icon-colour");
	}

	parsedCallback() {
		if (this.icon) {
			const headerIcon = document.createElementWithContents("chip-icon", null, { icon: this.icon });
			if (this.iconColour) { headerIcon.colour = this.iconColour; }

			this.prepend(headerIcon);
		}
	}
}